// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB1DWD2CWWoc9n-p7jdheZV4GIN87H8ObQ",
  authDomain: "wedding-website-908a2.firebaseapp.com",
  projectId: "wedding-website-908a2",
  storageBucket: "wedding-website-908a2.firebasestorage.app",
  messagingSenderId: "224186954984",
  appId: "1:224186954984:web:5cae2ef32b7fae1d8a055d",
  measurementId: "G-5R2GKGH26K",
  databaseURL: "https://wedding-website-908a2-default-rtdb.firebaseio.com"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const database = getDatabase(app);

export { app, analytics, database }; 